import * as React from "react";
import {AccountPageWrapper} from "components/account/widgets/AccountPageWrapper";
import {UIState} from "data/UIState";
import {PageEnums} from "components/nav/PageEnums";
import {AccountNavCard} from "components/account/widgets/AccountNavCard";
import {NavAvatar} from "components/nav/NavAvatar";
import {ParticipationSettingsIcon} from "components/widgets/icons/ParticipationSettingsIcon";
import {ShieldIcon} from "components/widgets/icons/ShieldIcon";
import {CircleContainer} from "components/widgets/icons/CircleContainer";
import {AccountContentContainer} from "components/account/widgets/AccountContentContainer";
import {IAccountPage, AccountPages} from "components/account/Account";


import "./AccountOverview.pcss";
import {handleSpacePressed} from "utils";

interface Props {
  onChangeAccountPage:(page:IAccountPage) => void;
}

export function AccountOverview(props: Props): JSX.Element {
  return (
    <AccountPageWrapper
      title={"Account"}
      subTitle={""}
      backOrCloseAction={()=>{ UIState.currentPage = PageEnums.dashboard }}
      backOrCloseLabel={"Back to Dashboard"}
    >
      <AccountContentContainer>

        <AccountNavCard
          icon={<NavAvatar user={UIState.user} variant={'large'} style={{width:'48px', height:'48px', lineHeight:'48px'}} />}
          title={`${UIState.user.firstName} ${UIState.user.lastName}`}
          titleNotBold={UIState.user.nickname?` (@${UIState.user.nickname})`:undefined}
          subTitle={UIState.user.email}
          buttonAction={()=>{ props.onChangeAccountPage(AccountPages.Profile); }}
          buttonLabel={"Edit Profile"}
        />

        <AccountNavCard
          icon={<CircleContainer><ParticipationSettingsIcon /></CircleContainer>}
          title={"Participation Settings"}
          subTitle={"Manage program participation"}
          buttonAction={()=>{ props.onChangeAccountPage(AccountPages.AccountParticipation); }}
          buttonLabel={"Manage Participation Settings"}
        />

        <AccountNavCard
          icon={<CircleContainer><ShieldIcon /></CircleContainer>}
          title={"Data & Privacy"}
          subTitle={"Data export & account removal"}
          buttonAction={()=>{ props.onChangeAccountPage(AccountPages.DataPrivacy); }}
          buttonLabel={"Manage Data & Privacy"}
        />

        <div className="account-logout">
          <a onClick={() => {
              UIState.clear();
              return true;
            }}
            onKeyDown={(e)=>{ handleSpacePressed(e, () => {
              UIState.clear();
              return true;
            })}}
            href={"/logout"}>Sign Out</a>
        </div>

      </AccountContentContainer>

    </AccountPageWrapper>
  );

}